<template>
	<OneOnOneListCardLayout :class="classes">
		<template #favorite>
			<Skeleton class="one-on-one-list-skeleton-card__skeleton" />
		</template>
		<template #name>
			<Skeleton class="one-on-one-list-skeleton-card__skeleton" />
		</template>
		<template #status>
			<Skeleton class="one-on-one-list-skeleton-card__skeleton" />
		</template>
		<template #role>
			<Skeleton class="one-on-one-list-skeleton-card__skeleton" />
		</template>
		<template #chevron>
			<Skeleton class="one-on-one-list-skeleton-card__skeleton" />
		</template>
	</OneOnOneListCardLayout>
</template>

<script>
import Skeleton from "primevue/skeleton";
import OneOnOneListCardLayout from "./OneOnOneListCardLayout";

export default {
	name: "OneOnOneListSkeletonCard",
	components: {
		OneOnOneListCardLayout,
		Skeleton,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"one-on-one-list-skeleton-card": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.one-on-one-list-skeleton-card {
	min-height: 1.875rem;
}

.one-on-one-list-skeleton-card__skeleton {
	margin-right: 1rem;
}
</style>
